import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { Reveal } from '../Reveal';
import { siteConfig } from '../../data/siteConfig';
export function GuaranteeSection() {
  const days = siteConfig.guaranteeDays;
  return <section className="bg-cream py-16 md:py-[84px]" data-id="element-60" data-mp="1kau7ymma742j">
      <div className="mx-auto max-w-[960px] px-5" data-id="element-61" data-mp="1fcskzqlqikls">
        <Reveal className="grid items-center gap-11 rounded-[32px] border-2 border-tangerine bg-white px-[22px] py-[30px] text-center shadow-card md:grid-cols-[240px_1fr] md:p-10 md:text-left" data-id="element-62" data-mp="1fbzorjkejdhw">
          <div className="mx-auto flex h-[180px] w-[180px] flex-col items-center justify-center rounded-full bg-tangerine text-center font-display text-white shadow-[inset_0_0_0_8px_#E8832F,inset_0_0_0_11px_#fff] md:h-[220px] md:w-[220px]" aria-label={`Garantía de ${days} días, 100% de tu dinero`} data-id="element-63" data-mp="15dto15ac0dem">
            <span className="text-base font-bold tracking-[0.12em]" data-id="element-64" data-mp="2vooi6myf3hac">GARANTÍA</span>
            <b className="text-[60px] font-extrabold leading-[0.9] md:text-[76px]" data-id="element-65" data-mp="2qspm0d6ukuzd">{days}</b>
            <span className="text-base font-bold tracking-[0.12em]" data-id="element-66" data-mp="1g3acda13qpns">DÍAS</span>
            <small className="mt-1.5 text-xs font-semibold opacity-95" data-id="element-67" data-mp="1l4zpqwbsrff1">100% de tu dinero</small>
          </div>
          <div data-id="element-68" data-mp="175q6fnsao56u">
            <p className="mb-3.5 inline-flex items-center gap-2 font-display text-[13px] font-bold uppercase tracking-[0.14em] text-tangerine" data-id="element-69" data-mp="176013ooab0iv">
              <ShieldCheck className="h-4 w-4" aria-hidden="true" data-id="element-70" data-mp="1zsaykqglglbg" />
              Riesgo cero
            </p>
            <h2 className="text-[28px] font-extrabold leading-[1.1] text-forest md:text-[38px]" data-id="element-71" data-mp="23uo3jcniof76">
              Pruébalo {days} días. Si no te sirve,{' '}
              <em className="not-italic text-tangerine" data-id="element-72" data-mp="1q16uwmwdcmvx">te devolvemos todo</em>.
            </h2>
            <p className="mt-4 text-[17px] text-muted md:text-[19px]" data-id="element-73" data-mp="1uzzwbgydsnfq">
              Descarga el kit, úsalo con tus clientes, publica los posts. Si en los próximos{' '}
              <b data-id="element-74" data-mp="2nj6tvxk9dyng">{days} días</b> sientes que no vale lo que pagaste, nos escribes y te devolvemos el
              100% de tu dinero. Sin preguntas incómodas.
            </p>
            <p className="mt-4 text-[17px] font-semibold text-forest md:text-[19px]" data-id="element-75" data-mp="2sf16qtxcra7v">
              El riesgo es todo nuestro. Tú solo tienes para ganar.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}